export default __webpack_public_path__ + "static/media/thumbnail.92f153ed.png";